import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  logo,
  section2partnership,
  OnlineBookingSystemIcon,
  wilsonLogo,
  underArmourLogo,
  NSCALogo,
  TeamSnapLogo,
  sklzLogo,
  Analytics,
  StarIconRed,
  ChatIconRed,
  AthleteImg,
  jsonNgoProfile,
  leeChenProfile,
  yeLinProfile,
  jsonProfile,
  vincentProfile,
  whatOurPartnerSay,
  partnerSayingLogo,
  arrowImage,
  HeadingBg,
  rightArrow1,
  rightArrow2,
  ArrowUpRightWhite,
  ForwardArrow,
  RightLongArrow,
  LeftLongArrow,
  SchoolImg,
  ClubPartnershipsImg,
  PartnershipMobileArrow1,
  PartnershipMobileArrow2,
} from "../../../constant/imagePath";
import { AfterLoginHeader } from "../../../stories/AfterLoginHeader/AfterLoginHeader";
import { PartnershipProgramCard } from "../../../stories/PartnershipProgramCard/PartnershipProgramCard";
import { UnsortedStep } from "../../../stories/UnsortedStep1/UnsortedStep";
import { Footer } from "../../../stories/Footer/Footer";
import Colors from "../../../stories/assets/Colors";
import Fonts from "../../../stories/assets/Fonts";
import { Button } from "../../../stories/Button/Button";
import { MobileHeader } from "../../../stories/MobileHeader/MobileHeader";

import classes from "./PartnershipMobile.module.css";
import { PlayCard } from "../../../stories/PlayCard/PlayCard";
import { isMobileViewHook } from "../../../CustomHooks/isMobileViewHook";
import { MobilePartnershipProgramCard } from "../../../stories/MobilePartnershipProgramCard/MobilePartnershipProgramCard";
import { MobileFooter } from "../../../stories/MobileFooter/MobileFooter";

const demoData = [
  {
    logo: wilsonLogo,
  },
  {
    logo: underArmourLogo,
  },
  {
    logo: NSCALogo,
  },
  {
    logo: TeamSnapLogo,
  },
  {
    logo: sklzLogo,
  },
];

const demoCardData = [
  {
    stepNo: "1",
    icon: Analytics,
    title: "Let us know about your training goals",
    tagline: "You can browse through all coach profiles and sort the results.",
  },
  {
    stepNo: "2",
    icon: StarIconRed,
    title: "Book to start training",
    tagline: "After you book your coach, you'll receive each others contacts.",
  },
  {
    stepNo: "3",
    icon: ChatIconRed,
    title: "Learn new skills, gain confidence",
    tagline: "Remember, you're in good hands with our customer support team.",
  },
];

const partnershipProgramCardData = [
  {
    image: AthleteImg,
    heading: "Athlete",
    description:
      "All of our coaches have extensive coaching experience and are required to pass rigorous background checks.",
  },
  {
    image: SchoolImg,
    heading: "School",
    description:
      "Every coaching session can be booked in minutes through Lytesnap and all financial transactions are securely processed online.",
  },
  {
    image: ClubPartnershipsImg,
    heading: "Club Partnerships",
    description:
      "We are committed to helping you find the right coach, and we back that up with our 100% money-back guarantee.",
  },
];

const profileCardData = [
  {
    image: jsonNgoProfile,
    name: "Jason Ngo",
    designation: "CEO and co-founder",
  },
  {
    image: leeChenProfile,
    name: "Lee Chen-Kai",
    designation: "COO",
  },
  {
    image: yeLinProfile,
    name: "Ye Lin",
    designation: "CFO",
  },
  {
    image: jsonProfile,
    name: "Lee Chen-Kai",
    designation: "COO",
  },
  {
    image: vincentProfile,
    name: "Lee Chen-Kai",
    designation: "COO",
  },
];

function PartnershipMobile() {
  return (
    <div>
      <Container fluid className="p-0">
        <Row className="g-0">
          {/* Section 1 */}
          <Col sm={12}>
            <div className={classes.headSection}>
              <Row className="g-0">
                <Col sm={12}>
                  <MobileHeader isLogo={true} logo={logo} isAvatar={true} />
                </Col>
                <Col sm={12}>
                  <h3
                    className={classes.headSectionText}
                    style={{ color: Colors.white, ...Fonts.h3 }}
                  >
                    <span>Let's Work</span>
                    <span className={classes.headingBg}>
                      &nbsp;&nbsp;together&nbsp;&nbsp;&nbsp;
                      <img src={HeadingBg} />
                    </span>
                  </h3>
                </Col>
                <Col sm={12}>
                  <div className={classes.textWithBtn}>
                    <p
                      style={{
                        ...Fonts.p1,
                        fontSize: "14px",
                        color: Colors.white,
                      }}
                    >
                      Partner with the company that is revolutionizing how
                      athletes and coaches train together.
                    </p>
                    <Button size={"Large"} primary={true}>
                      Apply now
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
          {/* Section 2 */}
          <Col
            sm={12}
            className={`${[classes.padding, classes.col2].join(" ")}`}
          >
            <Row className="g-0">
              <Col sm={12}>
                <div>
                  <div>
                    <img
                      src={OnlineBookingSystemIcon}
                      alt="OnlineBookingSystemIcon"
                    />
                  </div>
                  <p
                    style={{
                      ...Fonts.h2,
                      fontSize: "26px",
                      lineHeight: "32px",
                      color: Colors.neutralShadesOfNero,
                      marginTop: "24px",
                      letterSpacing: "-0.01rem",
                    }}
                  >
                    Why partner with Lytesnap?
                  </p>
                  <p style={{ ...Fonts.p1, marginTop: "24px" }}>
                    Lytesnap is a community where athletes, parents, and coaches
                    go to talk about and share everything they know and love
                    about sports and fitness. Tryout tips, success stories, or
                    the hottest youth sports news - Lytesnap has you covered.
                  </p>
                  <Button
                    label="Apply Now"
                    primary={true}
                    customStyle={{
                      width: "200px",
                      height: "56px",
                      marginTop: "32px",
                    }}
                  />
                </div>
              </Col>
              <Col sm={12}>
                <div className={classes.section2Img}>
                  <img src={section2partnership} alt="partnership" />
                </div>
              </Col>
            </Row>
          </Col>
          {/* Section 3 */}
          <Col
            sm={12}
            className={`${[classes.padding, classes.col3].join(" ")}`}
          >
            <h3
              style={{
                ...Fonts.h3,
                fontSize: "24px",
                lineHeight: "32px",
                color: Colors.neutralShadesOfNero,
              }}
            >
              Join our other high-growth partners
            </h3>
            {/* Brand Logos */}
            <Row
              className={`g-0 ${[classes.brandLogosBox].join(" ")}`}
              style={{ borderColor: Colors.neutralShadesOfWhisper }}
            >
              {demoData?.map((item) => {
                return (
                  <Col sm={12}>
                    <div
                      className={classes.logoBox}
                      style={{ color: Colors.neutralShadesOfWhisper }}
                    >
                      <img src={item?.logo} />
                    </div>
                  </Col>
                );
              })}
            </Row>

            {/* End of Brand Logos */}
          </Col>
          {/* Section 4 */}
          <Col
            sm={12}
            className={`${[classes.col4].join(" ")}`}
            style={{ background: Colors.neutralShadesOfWhiteSmoke }}
          >
            <h2
              style={{
                ...Fonts.h2,
                color: Colors.neutralShadesOfNero,
                fontSize: "26px",
                lineHeight: "32px",
              }}
            >
              Here's how it
              <span className={classes.headingBg}>
                &nbsp;works
                <img src={HeadingBg} />
                &nbsp; &nbsp;
              </span>
            </h2>
            <div className={classes.cards}>
              {demoCardData?.map((item, index) => {
                return (
                  <div>
                    {partnershipProgramCardData?.length - 1 !== index && (
                      <img
                        src={
                          index % 2 === 0
                            ? PartnershipMobileArrow2
                            : PartnershipMobileArrow1
                        }
                        alt=""
                        className={classes.cardInnerContainerImg}
                      />
                    )}

                    <UnsortedStep data={item} />
                  </div>
                );
              })}
            </div>
          </Col>
          {/* Section 5 */}
          <Col
            sm={12}
            className={`${[classes.padding, classes.col5].join(" ")}`}
          >
            <h2
              style={{
                ...Fonts.h2,
                color: Colors.neutralShadesOfNero,
                fontSize: "26px",
                lineHeight: "32px",
                letterSpacing: "-1%",
              }}
            >
              Who the partnership
              <span className={classes.headingBg}>
                {" "}
                program is
                <img src={HeadingBg} />{" "}
              </span>
              for?
            </h2>
            {/* Partnerships cards */}
            <div className={classes.partnershipsCards}>
              {partnershipProgramCardData?.map((item, index) => {
                return (
                  <div>
                    <MobilePartnershipProgramCard
                      image={item?.image}
                      heading={item?.heading}
                      description={item?.description}
                      customStyle={{ padding: "0px" }}
                    />
                  </div>
                );
              })}
            </div>
            {/* End of Partnerships cards */}
          </Col>
          {/* Section 6 */}
          <Col
            sm={12}
            className={`${[classes.padding, classes.col6].join(" ")}`}
          >
            <h2
              style={{
                ...Fonts.h2,
                color: Colors.neutralShadesOfNero,
                fontSize: "26px",
                lineHeight: "32px",
              }}
            >
              Get to&nbsp;
              <span className={classes.headingBg}>
                know us
                <img src={HeadingBg} />
                &nbsp; &nbsp;
              </span>
            </h2>
            {/* Cards */}
            <div className={classes.getToKnowCards}>
              {profileCardData?.map((item) => {
                return (
                  <div>
                    <PlayCard
                      icon={item.image}
                      title={item.name}
                      value={item.designation}
                      customStyle={{ width: "100%" }}
                      iconStyle={{
                        width: "100%",
                        height: "164px",
                        objectFit: "cover",
                        objectPosition: "center center",
                        borderRadius: "12px",
                      }}
                      titleStyle={{
                        textAlign: "center",
                        width: "100%",
                        marginTop: "16px",
                        ...Fonts.h5,
                        color: Colors.neutralShadesOfNero,
                      }}
                      valueStyle={{
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                        marginTop: "8px",
                        ...Fonts.p1,
                        color: Colors.neutralShadesOfDimGray,
                      }}
                    />
                  </div>
                );
              })}
            </div>
            {/*End Of Cards */}
          </Col>
          {/* Section 7 */}
          <Col
            sm={12}
            className={`${[classes.padding, classes.col7].join(" ")}`}
            style={{ background: Colors.neutralShadesOfWhiteSmoke }}
          >
            <h2
              style={{
                ...Fonts.h2,
                color: Colors.neutralShadesOfNero,
                fontSize: "26px",
                lineHeight: "32px",
              }}
            >
              What our partners are saying
            </h2>
            {/* Image With Icons */}
            <div className={classes.imgWithBtns}>
              <div className={`${[classes.imgBox].join(" ")}`}>
                <img src={whatOurPartnerSay} />
              </div>
              {/* Arrows */}
              <div className={classes.arrows}>
                <img src={LeftLongArrow} />
                <img src={RightLongArrow} />
              </div>
            </div>
            {/*  */}
            <p
              style={{
                ...Fonts.h5,
                color: Colors.neutralShadesOfNero,
                marginTop: "46px",
              }}
            >
              “I am very fond of the idea of CoachUp and enthusiastic about it.
              Anytime you can have extra training, guidance, and help in
              something that you enjoy doing, and in which you have shown the
              capacity and desire to improve.”
            </p>
            <div className={classes.logoWithTitle}>
              <div>
                <img src={partnerSayingLogo} alt="" />
              </div>
              <div className={classes.nameAndDesignation}>
                <h5
                  style={{
                    ...Fonts.h5,
                    color: Colors.neutralShadesOfNero,
                  }}
                >
                  Truman So
                </h5>
                <p
                  style={{
                    ...Fonts.p1,
                    color: Colors.neutralShadesOfNero,
                  }}
                >
                  Technology Partnerships Lead at Under Armour
                </p>
              </div>
            </div>
            <div className={classes.applyNowButton}>
              <Button
                primary={true}
                size="lg"
                label="Apply Now"
                customStyle={{ width: "100%", height: "56px" }}
              />
            </div>
            {/*  */}
          </Col>
          {/* Footer */}
          <Col sm={12}>
            <MobileFooter />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default PartnershipMobile;
